
export const api = {
    stores: process.env.REACT_APP_API_URL + 'stores',
};

export default api;